import React from 'react';
import { Container } from 'seduo-ui';
import cn from 'classnames';
export default () => (<footer role="contentinfo" className={cn('footer')}>
        <Container className="text-center">
            <p>
                <a href="https://www.seduo.cz">Seduo.cz</a>
            </p>
        </Container>
    </footer>);
